import { observable, action } from 'mobx';
import camelCase from 'lodash/camelCase';
import isFunction from 'lodash/isFunction';
import { Map } from '../classes';

class ScriptsLoaderStore {
  @observable
  mapsjsCoreStatus;
  @observable
  mapsjsMapeventsStatus;

  mapsjsCoreInit() {}

  mapsjsMapeventsInit() {
    Map.init(window.H);
  }

  @action
  load(filename) {
    const _filename = camelCase(filename.split('.')[0]);
    if (ScriptsLoaderStore.prototype.hasOwnProperty(`${_filename}Status`)) {
      if (isFunction(ScriptsLoaderStore.prototype[`${_filename}Init`])) {
        this[`${_filename}Init`].apply(this);
      } else {
        console.warn(`no init available for ${filename}`);
      }
      this[`${_filename}Status`] = 'loaded';
    } else {
      console.warn(`no observable available for ${filename}`);
    }
  }
}

export default new ScriptsLoaderStore();



// WEBPACK FOOTER //
// ./src/stores/scriptsLoaderStore.js